"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridExpandCollapsePlugin = void 0;
const embeddedCellProcessor_1 = require("./processors/embeddedCellProcessor");
const separateColumnProcessor_1 = require("./processors/separateColumnProcessor");
const GridExpandCollapsePluginColumnType_1 = require("./types/GridExpandCollapsePluginColumnType");
const expandableGridRow_1 = require("../../renderers/expandableGridRow");
function gridExpandCollapsePlugin(config) {
    return () => {
        return {
            processColumns: (columns) => {
                if (config.columnType === GridExpandCollapsePluginColumnType_1.GRID_EXPAND_COLLAPSE_PLUGIN_COLUMN_TYPE.embeddedCell) {
                    return (0, embeddedCellProcessor_1.embeddedCellProcessor)(columns, config);
                }
                return (0, separateColumnProcessor_1.separateColumnProcessor)(columns, config);
            },
            rowRenderer: (0, expandableGridRow_1.createGridExpandableRowRenderer)({
                getMetaByIndex: config.getMetaByIndex,
                loadingRowTitle: config.loadingRowTitle
            })
        };
    };
}
exports.gridExpandCollapsePlugin = gridExpandCollapsePlugin;
//# sourceMappingURL=gridExpandCollapsePlugin.js.map